// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Gemeinsame Bausteine der "Instrument"-Formensprache.
 * Note (Datenfeld-Rahmen), Steps (Skala), MenuPath, Ui-Label, WatchText, Setting, Tag, Label.
 */

/* Mono-Beschriftung (Eyebrow, Feldname) */
.ui-eyebrow {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

/* ---------- Note: Hinweis im Datenfeld-Rahmen ---------- */
.note {
  --note-color: var(--accent-primary);
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem;
  margin: 1.4rem 0 1rem;
  padding: 1.15rem 1.1rem 1rem;
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
}

.note::after {
  content: '';
  position: absolute;
  inset: -1px;
  pointer-events: none;
  background:
    linear-gradient(var(--note-color), var(--note-color)) top right / 12px 2px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) top right / 2px 12px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) bottom left / 12px 2px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) bottom left / 2px 12px no-repeat;
}

.note-label {
  position: absolute;
  top: -0.62rem;
  left: 0.8rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.4rem;
  background: var(--note-ground, var(--bg-primary));
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  line-height: 1.2;
  color: var(--note-color);
}

.note > p,
.note > ul,
.note > ol {
  margin: 0;
  color: var(--text-primary);
  font-size: 0.98rem;
}

.note ul,
.note ol {
  padding-left: 1.2rem;
}

.note-warn {
  --note-color: var(--signal);
  border-color: color-mix(in srgb, var(--signal) 45%, var(--border-primary));
}

.note-warn .note-label::before {
  content: '';
  width: 0.9rem;
  height: 0.55rem;
  background: repeating-linear-gradient(-45deg, var(--signal) 0 2px, transparent 2px 4px);
}

.note-tip {
  --note-color: var(--accent-secondary);
}

/* ---------- Frame: Fläche mit Eckmarken (Produktbild, Icon-Kachel) ----------
 * Zwei Eckwinkel in Akzentfarbe; beim Hover laufen sie die Kanten entlang,
 * bis der ganze Rahmen markiert ist. */
.frame {
  --frame-color: var(--accent-primary);
  --frame-tick: 14px;
  position: relative;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.frame::after {
  content: '';
  position: absolute;
  inset: -1px;
  pointer-events: none;
  background:
    linear-gradient(var(--frame-color), var(--frame-color)) top left no-repeat,
    linear-gradient(var(--frame-color), var(--frame-color)) top left no-repeat,
    linear-gradient(var(--frame-color), var(--frame-color)) bottom right no-repeat,
    linear-gradient(var(--frame-color), var(--frame-color)) bottom right no-repeat;
  background-size:
    var(--frame-tick) 2px,
    2px var(--frame-tick),
    var(--frame-tick) 2px,
    2px var(--frame-tick);
  transition: background-size 0.6s cubic-bezier(0.3, 0.7, 0.2, 1);
}

.frame-hover:hover .frame::after,
.frame-hover:focus-visible .frame::after,
a.frame:hover::after,
a.frame:focus-visible::after {
  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;
}

/* Einmaliges Nachzeichnen beim Laden (Produktseite) */
.frame-trace::after {
  animation: frame-trace 1.6s cubic-bezier(0.3, 0.7, 0.2, 1) 0.15s both;
}

@keyframes frame-trace {
  0% {
    background-size: 0 2px, 2px 0, 0 2px, 2px 0;
  }
  55% {
    background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;
  }
  100% {
    background-size: var(--frame-tick) 2px, 2px var(--frame-tick), var(--frame-tick) 2px, 2px var(--frame-tick);
  }
}

/* ---------- Themen-Icons (GuideIcons.tsx) ----------
 * Jedes Icon trägt eine Themenfarbe (data-tone): das Akzent-Detail in dieser Farbe,
 * die Kachel dahinter leicht getönt. Wasser ist ganz blau. */
.guide-icon {
  --tone: var(--tone-accent);
  flex-shrink: 0;
  color: var(--ink, var(--tone));
}

.guide-icon[data-tone="accent"] { --tone: var(--tone-accent); }
.guide-icon[data-tone="sun"] { --tone: var(--tone-sun); }
.guide-icon[data-tone="water"] { --tone: var(--tone-water); }
.guide-icon[data-tone="moon"] { --tone: var(--tone-moon); }
.guide-icon[data-tone="health"] { --tone: var(--tone-health); }
.guide-icon[data-tone="activity"] { --tone: var(--tone-activity); }
.guide-icon[data-tone="terrain"] { --tone: var(--tone-terrain); }
.guide-icon[data-tone="chart"] { --tone: var(--tone-chart); }
.guide-icon[data-tone="air"] { --tone: var(--tone-air); }
.guide-icon[data-tone="key"] { --tone: var(--tone-key); }
.guide-icon[data-tone="display"] { --tone: var(--tone-display); }

.guide-icon .gi-ac {
  stroke: var(--ac, var(--tone));
}

.guide-icon .gi-fill {
  fill: var(--ac, var(--tone));
  stroke: none;
}


.icon-tile:has(> .guide-icon[data-tone="accent"]) { background: color-mix(in srgb, var(--tone-accent) 14%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="sun"]) { --frame-color: var(--tone-sun); background: color-mix(in srgb, var(--tone-sun) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="water"]) { --frame-color: var(--tone-water); background: color-mix(in srgb, var(--tone-water) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="moon"]) { --frame-color: var(--tone-moon); background: color-mix(in srgb, var(--tone-moon) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="health"]) { --frame-color: var(--tone-health); background: color-mix(in srgb, var(--tone-health) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="activity"]) { --frame-color: var(--tone-activity); background: color-mix(in srgb, var(--tone-activity) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="terrain"]) { --frame-color: var(--tone-terrain); background: color-mix(in srgb, var(--tone-terrain) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="chart"]) { --frame-color: var(--tone-chart); background: color-mix(in srgb, var(--tone-chart) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="air"]) { --frame-color: var(--tone-air); background: color-mix(in srgb, var(--tone-air) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="key"]) { --frame-color: var(--tone-key); background: color-mix(in srgb, var(--tone-key) 24%, var(--bg-secondary)); }
.icon-tile:has(> .guide-icon[data-tone="display"]) { --frame-color: var(--tone-display); background: color-mix(in srgb, var(--tone-display) 24%, var(--bg-secondary)); }

/* Icon in kleinem Rahmen mit Eckmarken */
.icon-tile {
  border-color: color-mix(in srgb, var(--frame-color) 35%, var(--border-primary));
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 3.25rem;
  height: 3.25rem;
  --frame-tick: 9px;
}

/* ---------- Steps: nummerierte Skala ---------- */
.steps {
  list-style: none;
  margin: 1rem 0;
  padding: 0;
  counter-reset: step;
}

.steps > li {
  counter-increment: step;
  position: relative;
  display: grid;
  grid-template-columns: 2.6rem minmax(0, 1fr);
  gap: 0.9rem;
  padding-bottom: 1.1rem;
}

.steps > li::before {
  content: counter(step, decimal-leading-zero);
  padding-top: 0.12rem;
  border-top: 2px solid var(--accent-primary);
  font-family: var(--font-mono);
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--accent-primary);
}

.steps > li::after {
  content: '';
  position: absolute;
  left: 0;
  top: 1.9rem;
  bottom: 0.2rem;
  width: 6px;
  background: repeating-linear-gradient(180deg, var(--border-secondary) 0 1px, transparent 1px 7px);
}

.steps > li:last-child {
  padding-bottom: 0.2rem;
}

.steps > li:last-child::after {
  display: none;
}

.step-body {
  display: grid;
  gap: 0.45rem;
  min-width: 0;
}

.step-body > p {
  margin: 0;
  color: var(--text-primary);
}

.step-title {
  font-family: var(--font-body);
  font-size: 1.02rem;
  font-weight: 700;
  text-transform: none;
}

/* ---------- MenuPath ---------- */
.menu-path {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.1rem;
  max-width: 100%;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  line-height: 1.4;
  vertical-align: middle;
}

.menu-path-item {
  padding: 0.12rem 0.4rem;
  border-bottom: 1px solid var(--accent-primary);
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.menu-path-item:last-child {
  background: var(--accent-soft);
}

.menu-path-sep {
  padding-inline: 0.15rem;
  color: var(--text-tertiary);
}

/* ---------- Inline: Button in App, Anzeige auf Uhr, Name einer Einstellung ---------- */
.ui-label {
  display: inline-block;
  padding: 0 0.35rem;
  border: 1px solid var(--text-tertiary);
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: 0.82em;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-primary);
  white-space: nowrap;
}

.watch-text {
  padding: 0.05em 0.35em;
  background: var(--accent-soft);
  border-radius: 2px;
  font-family: var(--font-mono);
  font-size: 0.88em;
  color: var(--text-primary);
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}

.setting-name {
  font-family: var(--font-mono);
  font-size: 0.86em;
  color: var(--text-primary);
  border-bottom: 1px dashed var(--accent-primary);
  overflow-wrap: anywhere;
}

/* ---------- Tags ---------- */
.tag {
  display: inline-block;
  padding: 0.08rem 0.4rem;
  border: 1px solid var(--accent-primary);
  font-family: var(--font-mono);
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.4;
  color: var(--accent-primary);
  white-space: nowrap;
}

.tag-signal {
  border-color: var(--signal);
  color: var(--signal);
}

.tag-muted {
  border-color: var(--text-tertiary);
  color: var(--text-tertiary);
}

/* ---------- Bezel-Skala als Trenner ---------- */
.bezel-rule {
  height: 14px;
  border: 0;
  margin: 2.5rem 0;
  opacity: 0.7;
  background:
    repeating-linear-gradient(90deg, var(--border-secondary) 0 1px, transparent 1px 8px) bottom / 100% 6px no-repeat,
    repeating-linear-gradient(90deg, var(--text-tertiary) 0 2px, transparent 2px 40px) bottom / 100% 12px no-repeat;
}

/* ---------- Brotkrumen ---------- */
.breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.2rem 0.45rem;
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.04em;
  color: var(--text-tertiary);
}

.breadcrumbs a {
  color: var(--text-secondary);
}

.breadcrumbs a:hover {
  color: var(--accent-primary);
}

.breadcrumbs li + li::before {
  content: '›';
  margin-right: 0.45rem;
  color: var(--text-tertiary);
}

/* ---------- Gilt für ---------- */
.applies-to {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.applies-to .ui-eyebrow {
  margin-right: 0.3rem;
}

.applies-to a,
.applies-to span.applies-chip {
  padding: 0.12rem 0.45rem;
  border: 1px solid var(--border-primary);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  color: var(--text-primary);
}

.applies-to a:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

/* ---------- Schaltflächen ---------- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 44px;
  padding: 0.6rem 1.1rem;
  border: 1px solid var(--accent-primary);
  border-radius: var(--radius-sm);
  background: var(--accent-primary);
  color: var(--on-accent);
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
}

.btn:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
  color: var(--on-accent);
}

.btn-outline {
  background: transparent;
  color: var(--accent-primary);
}

.btn-outline:hover {
  background: var(--accent-soft);
  color: var(--accent-primary);
}

.btn-signal {
  background: var(--neon-buy);
  border-color: var(--neon-buy);
  color: var(--on-neon);
  box-shadow: 0 0 0 3px var(--neon-buy-glow);
}

.btn-signal:hover {
  background: var(--neon-buy);
  border-color: var(--neon-buy);
  filter: brightness(1.08);
  color: var(--on-neon);
}

/* ---------- Link-Liste (Hilfe, Kontakt, Produktseite) ---------- */
.help-guide-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.help-guide-list li {
  border-bottom: 1px solid var(--border-primary);
}

.help-guide-list a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 0;
  color: var(--text-primary);
}

.help-guide-list a > svg {
  flex-shrink: 0;
  color: var(--text-tertiary);
}

.help-guide-list a:hover,
.help-guide-list a:hover > svg {
  color: var(--accent-primary);
}


/* ---------- Gruppierte Anleitungen (Hilfe, Produktseite) ---------- */
.guide-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 19rem), 1fr));
  gap: 2rem 2.5rem;
}

.guide-group {
  min-width: 0;
  scroll-margin-top: calc(var(--header-height) + 1rem);
}

.guide-group h3 {
  margin: 0 0 0.25rem;
  padding-bottom: 0.3rem;
  border-bottom: 2px solid var(--text-primary);
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 600;
  text-transform: uppercase;
}


/* ---------- Inline-Links, Definitionslisten, klappbare Fragen ---------- */
.inline-link {
  color: var(--accent-primary);
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

/* Definitionslisten (Formatcodes, Optionen, Begriffe) */
.def-list {
  display: grid;
  margin: 0.5rem 0 1.25rem;
  border-top: 1px solid var(--border-primary);
}

.def-list > div {
  display: grid;
  grid-template-columns: minmax(7rem, 12rem) minmax(0, 1fr);
  gap: 0.3rem 1.25rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border-primary);
}

.def-list dt {
  font-family: var(--font-mono);
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.def-list dd {
  margin: 0;
  color: var(--text-secondary);
}

.def-list dd p {
  margin: 0;
  color: var(--text-secondary);
}

.def-list dd p + p {
  margin-top: 0.5rem;
}

@media (max-width: 560px) {
  .def-list > div {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Klappbare Fragen */
.guide-faq {
  border-bottom: 1px solid var(--border-primary);
}

.guide-faq:first-of-type {
  border-top: 1px solid var(--border-primary);
}

.guide-faq summary {
  position: relative;
  padding: 0.9rem 2rem 0.9rem 0;
  font-weight: 700;
  cursor: pointer;
  list-style: none;
}

.guide-faq summary::-webkit-details-marker {
  display: none;
}

.guide-faq summary::after {
  content: '+';
  position: absolute;
  right: 0.25rem;
  top: 0.75rem;
  font-family: var(--font-mono);
  font-size: 1.1rem;
  color: var(--accent-primary);
}

.guide-faq[open] summary::after {
  content: '–';
}

.guide-faq-body {
  padding: 0 0 1rem;
}

.guide-faq-body p {
  color: var(--text-secondary);
}


/* VX/Elite-Vergleich (auch in der Kauf-Anleitung genutzt) */
.version-compare {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 1fr));
  gap: 1.25rem 2rem;
}

.version-col {
  min-width: 0;
  padding-top: 0.75rem;
  border-top: 2px solid var(--text-primary);
}

.version-col h3 {
  margin: 0 0 0.6rem;
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 600;
  text-transform: uppercase;
}

.version-col ul {
  margin: 0;
  padding-left: 1.1rem;
}

.version-col li + li {
  margin-top: 0.35rem;
}


/* ---------- Segmentierter Umschalter (Kaufen, Startseite) ---------- */
.segmented {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 1.25rem 0 1.5rem;
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.segmented button {
  min-height: 48px;
  padding: 0.6rem 0.75rem;
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.segmented button + button {
  border-left: 1px solid var(--border-secondary);
}

.segmented button.active {
  background: var(--text-primary);
  color: var(--bg-primary);
}


/* „Neu“: gefüllt und auffällig */
.tag.tag-new {
  border-color: var(--signal);
  background: var(--signal);
  color: #fff;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--signal) 25%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/ui.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB;;;;0FAIwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iDAAiD;EACjD,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;uCAEuC;AACvC;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB;;;;kFAIgF;EAChF;;;;yBAIuB;EACvB,+DAA+D;AACjE;;AAEA;;;;EAIE,uDAAuD;AACzD;;AAEA,sDAAsD;AACtD;EACE,qEAAqE;AACvE;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,uDAAuD;EACzD;EACA;IACE,2GAA2G;EAC7G;AACF;;AAEA;;6DAE6D;AAC7D;EACE,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;AAChC;;AAEA,kCAAkC,0BAA0B,EAAE;AAC9D,+BAA+B,uBAAuB,EAAE;AACxD,iCAAiC,yBAAyB,EAAE;AAC5D,gCAAgC,wBAAwB,EAAE;AAC1D,kCAAkC,0BAA0B,EAAE;AAC9D,oCAAoC,4BAA4B,EAAE;AAClE,mCAAmC,2BAA2B,EAAE;AAChE,iCAAiC,yBAAyB,EAAE;AAC5D,+BAA+B,uBAAuB,EAAE;AACxD,+BAA+B,uBAAuB,EAAE;AACxD,mCAAmC,2BAA2B,EAAE;;AAEhE;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;;AAGA,oDAAoD,2EAA2E,EAAE;AACjI,iDAAiD,8BAA8B,EAAE,wEAAwE,EAAE;AAC3J,mDAAmD,gCAAgC,EAAE,0EAA0E,EAAE;AACjK,kDAAkD,+BAA+B,EAAE,yEAAyE,EAAE;AAC9J,oDAAoD,iCAAiC,EAAE,2EAA2E,EAAE;AACpK,sDAAsD,mCAAmC,EAAE,6EAA6E,EAAE;AAC1K,qDAAqD,kCAAkC,EAAE,4EAA4E,EAAE;AACvK,mDAAmD,gCAAgC,EAAE,0EAA0E,EAAE;AACjK,iDAAiD,8BAA8B,EAAE,wEAAwE,EAAE;AAC3J,iDAAiD,8BAA8B,EAAE,wEAAwE,EAAE;AAC3J,qDAAqD,kCAAkC,EAAE,4EAA4E,EAAE;;AAEvK,yCAAyC;AACzC;EACE,+EAA+E;EAC/E,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,2CAA2C;EAC3C,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,cAAc;EACd,UAAU;EACV,iGAAiG;AACnG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,yFAAyF;AACzF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;EAC1B,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ;;mHAEiH;AACnH;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;;AAGA,uEAAuE;AACvE;EACE,aAAa;EACb,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;;AAGA,4EAA4E;AAC5E;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,qBAAqB;AACrB;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA,4DAA4D;AAC5D;EACE,aAAa;EACb,sEAAsE;EACtE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,wEAAwE;AACxE;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;;AAGA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,wEAAwE;AAC1E","sourcesContent":["/*\n * Gemeinsame Bausteine der \"Instrument\"-Formensprache.\n * Note (Datenfeld-Rahmen), Steps (Skala), MenuPath, Ui-Label, WatchText, Setting, Tag, Label.\n */\n\n/* Mono-Beschriftung (Eyebrow, Feldname) */\n.ui-eyebrow {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n/* ---------- Note: Hinweis im Datenfeld-Rahmen ---------- */\n.note {\n  --note-color: var(--accent-primary);\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.5rem;\n  margin: 1.4rem 0 1rem;\n  padding: 1.15rem 1.1rem 1rem;\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n\n.note::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  pointer-events: none;\n  background:\n    linear-gradient(var(--note-color), var(--note-color)) top right / 12px 2px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) top right / 2px 12px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) bottom left / 12px 2px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) bottom left / 2px 12px no-repeat;\n}\n\n.note-label {\n  position: absolute;\n  top: -0.62rem;\n  left: 0.8rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0 0.4rem;\n  background: var(--note-ground, var(--bg-primary));\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: var(--note-color);\n}\n\n.note > p,\n.note > ul,\n.note > ol {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 0.98rem;\n}\n\n.note ul,\n.note ol {\n  padding-left: 1.2rem;\n}\n\n.note-warn {\n  --note-color: var(--signal);\n  border-color: color-mix(in srgb, var(--signal) 45%, var(--border-primary));\n}\n\n.note-warn .note-label::before {\n  content: '';\n  width: 0.9rem;\n  height: 0.55rem;\n  background: repeating-linear-gradient(-45deg, var(--signal) 0 2px, transparent 2px 4px);\n}\n\n.note-tip {\n  --note-color: var(--accent-secondary);\n}\n\n/* ---------- Frame: Fläche mit Eckmarken (Produktbild, Icon-Kachel) ----------\n * Zwei Eckwinkel in Akzentfarbe; beim Hover laufen sie die Kanten entlang,\n * bis der ganze Rahmen markiert ist. */\n.frame {\n  --frame-color: var(--accent-primary);\n  --frame-tick: 14px;\n  position: relative;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n}\n\n.frame::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  pointer-events: none;\n  background:\n    linear-gradient(var(--frame-color), var(--frame-color)) top left no-repeat,\n    linear-gradient(var(--frame-color), var(--frame-color)) top left no-repeat,\n    linear-gradient(var(--frame-color), var(--frame-color)) bottom right no-repeat,\n    linear-gradient(var(--frame-color), var(--frame-color)) bottom right no-repeat;\n  background-size:\n    var(--frame-tick) 2px,\n    2px var(--frame-tick),\n    var(--frame-tick) 2px,\n    2px var(--frame-tick);\n  transition: background-size 0.6s cubic-bezier(0.3, 0.7, 0.2, 1);\n}\n\n.frame-hover:hover .frame::after,\n.frame-hover:focus-visible .frame::after,\na.frame:hover::after,\na.frame:focus-visible::after {\n  background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;\n}\n\n/* Einmaliges Nachzeichnen beim Laden (Produktseite) */\n.frame-trace::after {\n  animation: frame-trace 1.6s cubic-bezier(0.3, 0.7, 0.2, 1) 0.15s both;\n}\n\n@keyframes frame-trace {\n  0% {\n    background-size: 0 2px, 2px 0, 0 2px, 2px 0;\n  }\n  55% {\n    background-size: 100% 2px, 2px 100%, 100% 2px, 2px 100%;\n  }\n  100% {\n    background-size: var(--frame-tick) 2px, 2px var(--frame-tick), var(--frame-tick) 2px, 2px var(--frame-tick);\n  }\n}\n\n/* ---------- Themen-Icons (GuideIcons.tsx) ----------\n * Jedes Icon trägt eine Themenfarbe (data-tone): das Akzent-Detail in dieser Farbe,\n * die Kachel dahinter leicht getönt. Wasser ist ganz blau. */\n.guide-icon {\n  --tone: var(--tone-accent);\n  flex-shrink: 0;\n  color: var(--ink, var(--tone));\n}\n\n.guide-icon[data-tone=\"accent\"] { --tone: var(--tone-accent); }\n.guide-icon[data-tone=\"sun\"] { --tone: var(--tone-sun); }\n.guide-icon[data-tone=\"water\"] { --tone: var(--tone-water); }\n.guide-icon[data-tone=\"moon\"] { --tone: var(--tone-moon); }\n.guide-icon[data-tone=\"health\"] { --tone: var(--tone-health); }\n.guide-icon[data-tone=\"activity\"] { --tone: var(--tone-activity); }\n.guide-icon[data-tone=\"terrain\"] { --tone: var(--tone-terrain); }\n.guide-icon[data-tone=\"chart\"] { --tone: var(--tone-chart); }\n.guide-icon[data-tone=\"air\"] { --tone: var(--tone-air); }\n.guide-icon[data-tone=\"key\"] { --tone: var(--tone-key); }\n.guide-icon[data-tone=\"display\"] { --tone: var(--tone-display); }\n\n.guide-icon .gi-ac {\n  stroke: var(--ac, var(--tone));\n}\n\n.guide-icon .gi-fill {\n  fill: var(--ac, var(--tone));\n  stroke: none;\n}\n\n\n.icon-tile:has(> .guide-icon[data-tone=\"accent\"]) { background: color-mix(in srgb, var(--tone-accent) 14%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"sun\"]) { --frame-color: var(--tone-sun); background: color-mix(in srgb, var(--tone-sun) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"water\"]) { --frame-color: var(--tone-water); background: color-mix(in srgb, var(--tone-water) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"moon\"]) { --frame-color: var(--tone-moon); background: color-mix(in srgb, var(--tone-moon) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"health\"]) { --frame-color: var(--tone-health); background: color-mix(in srgb, var(--tone-health) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"activity\"]) { --frame-color: var(--tone-activity); background: color-mix(in srgb, var(--tone-activity) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"terrain\"]) { --frame-color: var(--tone-terrain); background: color-mix(in srgb, var(--tone-terrain) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"chart\"]) { --frame-color: var(--tone-chart); background: color-mix(in srgb, var(--tone-chart) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"air\"]) { --frame-color: var(--tone-air); background: color-mix(in srgb, var(--tone-air) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"key\"]) { --frame-color: var(--tone-key); background: color-mix(in srgb, var(--tone-key) 24%, var(--bg-secondary)); }\n.icon-tile:has(> .guide-icon[data-tone=\"display\"]) { --frame-color: var(--tone-display); background: color-mix(in srgb, var(--tone-display) 24%, var(--bg-secondary)); }\n\n/* Icon in kleinem Rahmen mit Eckmarken */\n.icon-tile {\n  border-color: color-mix(in srgb, var(--frame-color) 35%, var(--border-primary));\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 3.25rem;\n  height: 3.25rem;\n  --frame-tick: 9px;\n}\n\n/* ---------- Steps: nummerierte Skala ---------- */\n.steps {\n  list-style: none;\n  margin: 1rem 0;\n  padding: 0;\n  counter-reset: step;\n}\n\n.steps > li {\n  counter-increment: step;\n  position: relative;\n  display: grid;\n  grid-template-columns: 2.6rem minmax(0, 1fr);\n  gap: 0.9rem;\n  padding-bottom: 1.1rem;\n}\n\n.steps > li::before {\n  content: counter(step, decimal-leading-zero);\n  padding-top: 0.12rem;\n  border-top: 2px solid var(--accent-primary);\n  font-family: var(--font-mono);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--accent-primary);\n}\n\n.steps > li::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 1.9rem;\n  bottom: 0.2rem;\n  width: 6px;\n  background: repeating-linear-gradient(180deg, var(--border-secondary) 0 1px, transparent 1px 7px);\n}\n\n.steps > li:last-child {\n  padding-bottom: 0.2rem;\n}\n\n.steps > li:last-child::after {\n  display: none;\n}\n\n.step-body {\n  display: grid;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.step-body > p {\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.step-title {\n  font-family: var(--font-body);\n  font-size: 1.02rem;\n  font-weight: 700;\n  text-transform: none;\n}\n\n/* ---------- MenuPath ---------- */\n.menu-path {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem 0.1rem;\n  max-width: 100%;\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  line-height: 1.4;\n  vertical-align: middle;\n}\n\n.menu-path-item {\n  padding: 0.12rem 0.4rem;\n  border-bottom: 1px solid var(--accent-primary);\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n.menu-path-item:last-child {\n  background: var(--accent-soft);\n}\n\n.menu-path-sep {\n  padding-inline: 0.15rem;\n  color: var(--text-tertiary);\n}\n\n/* ---------- Inline: Button in App, Anzeige auf Uhr, Name einer Einstellung ---------- */\n.ui-label {\n  display: inline-block;\n  padding: 0 0.35rem;\n  border: 1px solid var(--text-tertiary);\n  border-radius: var(--radius-sm);\n  font-family: var(--font-mono);\n  font-size: 0.82em;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.watch-text {\n  padding: 0.05em 0.35em;\n  background: var(--accent-soft);\n  border-radius: 2px;\n  font-family: var(--font-mono);\n  font-size: 0.88em;\n  color: var(--text-primary);\n  box-decoration-break: clone;\n  -webkit-box-decoration-break: clone;\n}\n\n.setting-name {\n  font-family: var(--font-mono);\n  font-size: 0.86em;\n  color: var(--text-primary);\n  border-bottom: 1px dashed var(--accent-primary);\n  overflow-wrap: anywhere;\n}\n\n/* ---------- Tags ---------- */\n.tag {\n  display: inline-block;\n  padding: 0.08rem 0.4rem;\n  border: 1px solid var(--accent-primary);\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.4;\n  color: var(--accent-primary);\n  white-space: nowrap;\n}\n\n.tag-signal {\n  border-color: var(--signal);\n  color: var(--signal);\n}\n\n.tag-muted {\n  border-color: var(--text-tertiary);\n  color: var(--text-tertiary);\n}\n\n/* ---------- Bezel-Skala als Trenner ---------- */\n.bezel-rule {\n  height: 14px;\n  border: 0;\n  margin: 2.5rem 0;\n  opacity: 0.7;\n  background:\n    repeating-linear-gradient(90deg, var(--border-secondary) 0 1px, transparent 1px 8px) bottom / 100% 6px no-repeat,\n    repeating-linear-gradient(90deg, var(--text-tertiary) 0 2px, transparent 2px 40px) bottom / 100% 12px no-repeat;\n}\n\n/* ---------- Brotkrumen ---------- */\n.breadcrumbs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.2rem 0.45rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  letter-spacing: 0.04em;\n  color: var(--text-tertiary);\n}\n\n.breadcrumbs a {\n  color: var(--text-secondary);\n}\n\n.breadcrumbs a:hover {\n  color: var(--accent-primary);\n}\n\n.breadcrumbs li + li::before {\n  content: '›';\n  margin-right: 0.45rem;\n  color: var(--text-tertiary);\n}\n\n/* ---------- Gilt für ---------- */\n.applies-to {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.applies-to .ui-eyebrow {\n  margin-right: 0.3rem;\n}\n\n.applies-to a,\n.applies-to span.applies-chip {\n  padding: 0.12rem 0.45rem;\n  border: 1px solid var(--border-primary);\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  color: var(--text-primary);\n}\n\n.applies-to a:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n/* ---------- Schaltflächen ---------- */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 44px;\n  padding: 0.6rem 1.1rem;\n  border: 1px solid var(--accent-primary);\n  border-radius: var(--radius-sm);\n  background: var(--accent-primary);\n  color: var(--on-accent);\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.btn:hover {\n  background: var(--accent-hover);\n  border-color: var(--accent-hover);\n  color: var(--on-accent);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--accent-primary);\n}\n\n.btn-outline:hover {\n  background: var(--accent-soft);\n  color: var(--accent-primary);\n}\n\n.btn-signal {\n  background: var(--neon-buy);\n  border-color: var(--neon-buy);\n  color: var(--on-neon);\n  box-shadow: 0 0 0 3px var(--neon-buy-glow);\n}\n\n.btn-signal:hover {\n  background: var(--neon-buy);\n  border-color: var(--neon-buy);\n  filter: brightness(1.08);\n  color: var(--on-neon);\n}\n\n/* ---------- Link-Liste (Hilfe, Kontakt, Produktseite) ---------- */\n.help-guide-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.help-guide-list li {\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.help-guide-list a {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 0;\n  color: var(--text-primary);\n}\n\n.help-guide-list a > svg {\n  flex-shrink: 0;\n  color: var(--text-tertiary);\n}\n\n.help-guide-list a:hover,\n.help-guide-list a:hover > svg {\n  color: var(--accent-primary);\n}\n\n\n/* ---------- Gruppierte Anleitungen (Hilfe, Produktseite) ---------- */\n.guide-groups {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 19rem), 1fr));\n  gap: 2rem 2.5rem;\n}\n\n.guide-group {\n  min-width: 0;\n  scroll-margin-top: calc(var(--header-height) + 1rem);\n}\n\n.guide-group h3 {\n  margin: 0 0 0.25rem;\n  padding-bottom: 0.3rem;\n  border-bottom: 2px solid var(--text-primary);\n  font-family: var(--font-display);\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n\n/* ---------- Inline-Links, Definitionslisten, klappbare Fragen ---------- */\n.inline-link {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n}\n\n/* Definitionslisten (Formatcodes, Optionen, Begriffe) */\n.def-list {\n  display: grid;\n  margin: 0.5rem 0 1.25rem;\n  border-top: 1px solid var(--border-primary);\n}\n\n.def-list > div {\n  display: grid;\n  grid-template-columns: minmax(7rem, 12rem) minmax(0, 1fr);\n  gap: 0.3rem 1.25rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.def-list dt {\n  font-family: var(--font-mono);\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n.def-list dd {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.def-list dd p {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.def-list dd p + p {\n  margin-top: 0.5rem;\n}\n\n@media (max-width: 560px) {\n  .def-list > div {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Klappbare Fragen */\n.guide-faq {\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.guide-faq:first-of-type {\n  border-top: 1px solid var(--border-primary);\n}\n\n.guide-faq summary {\n  position: relative;\n  padding: 0.9rem 2rem 0.9rem 0;\n  font-weight: 700;\n  cursor: pointer;\n  list-style: none;\n}\n\n.guide-faq summary::-webkit-details-marker {\n  display: none;\n}\n\n.guide-faq summary::after {\n  content: '+';\n  position: absolute;\n  right: 0.25rem;\n  top: 0.75rem;\n  font-family: var(--font-mono);\n  font-size: 1.1rem;\n  color: var(--accent-primary);\n}\n\n.guide-faq[open] summary::after {\n  content: '–';\n}\n\n.guide-faq-body {\n  padding: 0 0 1rem;\n}\n\n.guide-faq-body p {\n  color: var(--text-secondary);\n}\n\n\n/* VX/Elite-Vergleich (auch in der Kauf-Anleitung genutzt) */\n.version-compare {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 1fr));\n  gap: 1.25rem 2rem;\n}\n\n.version-col {\n  min-width: 0;\n  padding-top: 0.75rem;\n  border-top: 2px solid var(--text-primary);\n}\n\n.version-col h3 {\n  margin: 0 0 0.6rem;\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.version-col ul {\n  margin: 0;\n  padding-left: 1.1rem;\n}\n\n.version-col li + li {\n  margin-top: 0.35rem;\n}\n\n\n/* ---------- Segmentierter Umschalter (Kaufen, Startseite) ---------- */\n.segmented {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  margin: 1.25rem 0 1.5rem;\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.segmented button {\n  min-height: 48px;\n  padding: 0.6rem 0.75rem;\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.segmented button + button {\n  border-left: 1px solid var(--border-secondary);\n}\n\n.segmented button.active {\n  background: var(--text-primary);\n  color: var(--bg-primary);\n}\n\n\n/* „Neu“: gefüllt und auffällig */\n.tag.tag-new {\n  border-color: var(--signal);\n  background: var(--signal);\n  color: #fff;\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--signal) 25%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
